import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Header from "../components/Header";

function CliffsidePark() {
  const cityName = "Cliffside Park";
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center" 
      style={{ backgroundImage: "url('blog13.png')" }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">Luxury Transportation Services in {cityName}, NJ</h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">{cityName}</span>
          </div>
        </div>
      </div>
    </section>
    <section className="bg-white py-8 sm:py-12 lg:py-16 px-4 sm:px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div><img src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" alt="Luxury Fleet" className="w-full h-96 object-cover rounded-lg shadow-lg" /></div>
          <div>
            <h2 className="font-bold text-black mb-3 leading-tight">Premium Limo Service in {cityName}, NJ</h2>
            <p className="mb-2 text-gray-900">Experience luxury transportation in {cityName} with Majestic Voyage USA. Professional limousine services for airport transfers, corporate events, weddings, and special occasions.</p>
            <p className="mb-3 text-gray-900">Our commitment to excellence makes us the preferred choice for transportation in {cityName}. Professional chauffeurs, luxury vehicles, and reliable service.</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="/booknow" className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center min-h-[44px] flex items-center justify-center">BOOK NOW</a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center min-h-[44px] flex items-center justify-center">CALL NOW</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="md:order-1 order-2">
            <h2 className="font-bold text-black mb-3 leading-tight">Airport Transfers & Corporate Transportation</h2>
            <p className="mb-2 text-gray-900">Reliable airport transfers to Newark, JFK, and LaGuardia. Professional chauffeurs ensure timely pickups for all your travel needs in {cityName}.</p>
            <p className="mb-3 text-gray-900">Corporate clients trust us for executive transportation and business meetings throughout {cityName} and the New York metropolitan area.</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="/booknow" className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center min-h-[44px] flex items-center justify-center">BOOK NOW</a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center min-h-[44px] flex items-center justify-center">CALL NOW</a>
            </div>
          </div>
          <div className="md:order-2 order-1"><img src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" alt="Luxury Fleet" className="w-full h-96 object-cover rounded-lg shadow-lg" /></div>
        </div>
      </div>
    </section>
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div><img src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" alt="Luxury Fleet" className="w-full h-96 object-cover rounded-lg shadow-lg" /></div>
          <div>
            <h2 className="font-bold text-black mb-3 leading-tight">Wedding & Special Event Transportation</h2>
            <p className="mb-2 text-gray-900">Make your special day memorable with elegant wedding and event transportation in {cityName}. Luxury vehicles for all your special occasions.</p>
            <p className="mb-3 text-gray-900">Trained chauffeurs provide discreet, courteous service ensuring your special moments are handled with care.</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="/booknow" className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center min-h-[44px] flex items-center justify-center">BOOK NOW</a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center min-h-[44px] flex items-center justify-center">CALL NOW</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="bg-white py-16 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="md:order-1 order-2">
            <h2 className="font-bold text-black mb-3 leading-tight">24/7 Availability & Professional Service</h2>
            <p className="mb-2 text-gray-900">Available 24/7, 365 days a year in {cityName}. Early morning airport pickups, late-night events, or weekend service - we're always ready.</p>
            <p className="mb-3 text-gray-900">All vehicles are regularly maintained, clean, and equipped with modern amenities. Professional, licensed chauffeurs committed to your safety.</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="/booknow" className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center min-h-[44px] flex items-center justify-center">BOOK NOW</a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center min-h-[44px] flex items-center justify-center">CALL NOW</a>
            </div>
          </div>
          <div className="md:order-2 order-1"><img src="https://majesticvoyageusa.com/assets/images/services/our-luxury-fleet.jpg" alt="Luxury Fleet" className="w-full h-96 object-cover rounded-lg shadow-lg" /></div>
        </div>
      </div>
    </section>
    <FAQ/><Footer/>
    </>
  );
}

export default CliffsidePark;

